/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';

import styles from '../styles';

interface ContentPlacementPropTypes {
  i18nKey: string;
  i18nContext?: string;
}

/**
 * Placement for translated copy. The translation can have
 * - one level of heading (wrapped with "<0></0>") (block element)
 * - basic HTML tags without attributes and at most one text child.
 * See documentation for react-i18next's Trans component for more details.
 *
 * For example:
 * "<0>My Heading</0><p><strong>Strong text</strong></p><p>Normal text</p>".
 */
const ContentPlacement: React.FC<ContentPlacementPropTypes> = ({
  i18nKey,
  i18nContext,
}) => {
  const t = useTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();
  if (!t(i18nKey)) {
    return null;
  }

  return (
    <div css={styles.dspContentPlacement}>
      {tMdMultiline(i18nKey, { context: i18nContext })}
    </div>
  );
};

export default ContentPlacement;
